// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentRegistrationModalLayout_offsetRegistrationPanel__xg1Ax {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppointmentRegistration/AppointmentRegistrationModalLayout.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".offsetRegistrationPanel {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"offsetRegistrationPanel": `AppointmentRegistrationModalLayout_offsetRegistrationPanel__xg1Ax`
};
export default ___CSS_LOADER_EXPORT___;
